import Vue from 'vue';
import Vuex from 'vuex';
import city from './modules/city';
import Axios from "axios";
import config from "./config";
Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        modalStatus: false,
        designFormStatus: false,
        freeOrderFormStatus: false,
        calculateSmartHousePrice: false,
        directorFormStatus: false,
        designProjectModalStatus: false,
        callbackStatus: false,
        overlayStatus: false,
        fastBueStatus: false,
        smartFastBuyFormStatus: false,
        mobileMenuStatus: false,
        cities: ['Московская область', 'Новосибирская область', 'Красноярский край', 'Кемеровская область', 'Томская область', 'Республика Алтай', 'Алтайский край'],
    },
    actions: {
        GET_DESIGN_PROJECT({commit}, status) {
            commit('setDesignProjectModalStatus', status);
        },
    },
    mutations: {
        setModalStatus: (state, active) => {
            state.modalStatus = active;
        },
        setDesignProjectModalStatus: (state, active) => {
            state.designProjectModalStatus = active;
        },
        setSmartFastBuyFormStatus: (state, active) => {
            state.smartFastBuyFormStatus = active;
        },
        setFastBueStatus: (state, active) => {
            state.fastBueStatus = active;
        },
        setCallbackStatus: (state, active) => {
            state.callbackStatus = active;
        },
        setDirectorFormStatus: (state, active) => {
            state.directorFormStatus = active;
        },
        setFreeOrderFormStatus: (state, active) => {
            state.freeOrderFormStatus = active;
        },
        setCalculateSmartHousePriceStatus: (state, active) => {
            state.calculateSmartHousePrice = active;
        },
        setDesignFormStatus: (state, active) => {
            state.designFormStatus = active;
        },
        setOverlayStatus: (state, active) => {
            state.overlayStatus = active;
        },
        setMobileMenuStatus: (state, active) => {
            state.mobileMenuStatus = active;
        },
    },
    getters: {
        designProjectModalStatus(state){
            return state.designProjectModalStatus;
        },
    },
	modules: {
		city,
	}
});
